



































































































































































































































import { Component } from "../../../Infrastructure/CorBase/CoreBase";
import PricelistTemplateDetailBase from "./PricelistTemplateDetailBase";

@Component
export default class PricelistTemplateDetail extends PricelistTemplateDetailBase {


    created() {
        this.returnRoute = "PricelistTemplateList";
        super.initializeRights('ACC_PricelistTemplate_Update', 'ACC_PricelistTemplate_Update', 'ACC_PricelistTemplate_Update', 'ACC_PricelistTemplate_Update');
        super.setMainDescription('pricelistTemplate.new', 'pricelistTemplate.detail');
        this.mainDataChanged = false;
    }

    preventRefresh(event: any) {
        if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
            event.preventDefault(); event.returnValue = "";
        }
    }

    beforeMount() {
        window.addEventListener("beforeunload", this.preventRefresh);
    }

    beforeDestroy() {
        window.removeEventListener("beforeunload", this.preventRefresh);
        this.$store.commit("formIsInEditMode", false);
        this.$store.commit("mainDataChanged", false);
    }

    mounted() {
        super.mounted();
    };

    update() {
        this.updateBase();
    }

    validate() {
        return this.validateBase();
    }

    isCorrectName(value: any) {
        this.isCorrectNameBase(value);
    }

    isCorrectIdentifier(value: any) {
        this.isCorrectIdentifierBase(value);
    }

    isCorrectVat(value: any) {
        this.isCorrectVarBase(value);
    }

    isCorrectUnit(value: any) {
        this.isCorrectUnitBase(value);
    }

    isCorrectDaily(value: any) {
        this.isCorrectDailyBase(value);
    }

    isCorrectMonthly(value: any) {
        this.isCorrectMonthlyBase(value);
    }

    isCorrectAmount(value: any) {
        this.isCorrectAmountBase(value);
    }

    isCorrectAmountFrom(value: any) {
        this.isCorrectAmountFromBase(value);
    }

    isCorrectAmountTo(value: any) {
        this.isCorrectAmountToBase(value);
    }


}
